<template>
  <label :class="$attrs.class ?? 'form_label'">
    <span v-html="value"></span>
    <span class="text-danger" v-if="required"> *</span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: 'FormInputLabel',

  props: {
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
